// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1xvaM","load2":"Spinner_load2__H2Ip1"};